const standards = [
  {
    no: "01",
    title: "真实可核",
    desc: "作品需基于真实经历与场景，能说清时间、地点与经过，不接受纯虚构的情节拼贴。",
  },
  {
    no: "02",
    title: "细节优先",
    desc: "评审更看重具体细节——一张表、一段录音、一句原话，往往比情绪化的结论更有说服力。",
  },
  {
    no: "03",
    title: "表达克制",
    desc: "不靠夸张标题吸引点击，鼓励平实、清楚、有条理的叙述，让读者自己得出结论。",
  },
  {
    no: "04",
    title: "尊重他人",
    desc: "不涉及人身攻击，不披露与内容无关的隐私信息，真实与善意可以同时成立。",
  },
];

export default function JudgingSection() {
  return (
    <section className="px-4 md:px-8 py-14 md:py-20 bg-background-100 border-y border-background-200">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <p className="font-label text-xs text-primary-600 tracking-[0.2em] uppercase">Judging</p>
          <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950 tracking-tight">
            我们怎么挑出优秀作品
          </h2>
          <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
            每一篇投稿都会经过初审与复审两道流程，最终入选作品集的内容，都要同时满足下面四条标准。
          </p>
          <div className="mt-7 inline-flex items-center gap-3 p-4 rounded-lg bg-accent-100 border border-accent-200">
            <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-500 text-primary-950 text-xl">
              <i className="ri-award-line" />
            </span>
            <span>
              <span className="block font-heading text-sm font-bold text-accent-950">本期需选出 30 篇优秀作品</span>
              <span className="mt-0.5 block text-xs text-accent-900">结果将于 11 月 20 日公布</span>
            </span>
          </div>
        </div>

        <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-5">
          {standards.map((item) => (
            <article key={item.no} className="p-5 md:p-6 rounded-lg bg-background-50 border border-background-200">
              <span className="font-heading text-3xl font-bold text-primary-200">{item.no}</span>
              <h3 className="mt-3 font-heading text-base md:text-lg font-bold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}